import { getLocalizedString } from "@icarius-localization/strings";
import {
    GroupsIcon,
    PersonalSheet,
    DocumentIcon,
    ShieldAlert,
} from "@icarius-icons";
import * as pages from "@icarius-pages/index";
import paths from "@icarius-router/paths";

export const getScreenRoutes = () => ({
    directory: {
        title: getLocalizedString("directory"),
        component: pages.Directory,
        path: paths.directory,
        icon: DocumentIcon(),
    },
    alerts: {
        title: getLocalizedString("alerts"),
        component: pages.Alerts,
        path: paths.alerts,
        icon: ShieldAlert(),
    },
    digitalDocuments: {
        title: getLocalizedString("digitalDocuments"),
        component: pages.Home,
        path: paths.digitalDocuments,
        icon: ShieldAlert(),
    },
    myPersonalData: {
        title: getLocalizedString("myPersonalData"),
        component: pages.MyPersonalData,
        path: paths.myPersonalData,
        icon: PersonalSheet(),
    },
    myGroups: {
        title: getLocalizedString("myGroupsTitle"),
        component: pages.MyGroups,
        path: paths.myGroups,
        icon: GroupsIcon,
    },
    assistanceAnalysis: {
        title: getLocalizedString("assistanceAnalysis"),
        component: pages.AssistanceAnalysis,
        path: paths.assistanceAnalysis,
    },
    alertsSettingsScreenSelector: {
        title: getLocalizedString("alertsSettings"),
        component: pages.AlertsSettingsScreenSelector,
        path: paths.alertsSettings,
    },
    alertsTemplates: {
        title: getLocalizedString("alertsTemplates"),
        component: pages.AlertsTemplates,
        path: paths.alertsTemplates,
        parentRoute: paths.alerts,
    },
    userAlertsSettings: {
        title: getLocalizedString("userAlertsSettings"),
        component: pages.AlertsSettings,
        path: paths.userAlertsSettings,
        parentRoute: paths.alerts,
    },
    systemAlertsSettings: {
        title: getLocalizedString("systemAlertsSettings"),
        component: pages.AlertsSettings,
        path: paths.systemAlertsSettings,
        parentRoute: paths.alerts,
    },
    kpiDefinition: {
        title: getLocalizedString("kpiDefinition"),
        component: pages.KPIdefinition,
        path: paths.kpiDefinition,
        parentRoute: paths.managementDefinition,
    },
    geoQueryDefinition: {
        title: getLocalizedString("geoQuery"),
        component: pages.GeoQueryDefinition,
        path: paths.geoQuery,
        parentRoute: paths.managementDefinition,
    },
    queryDefinition: {
        title: getLocalizedString("queryDefinition"),
        component: pages.QueryDefinition,
        path: paths.queryDefinition,
        parentRoute: paths.managementDefinition,
    },
    managementDefinition: {
        title: getLocalizedString("managementDefinition"),
        component: pages.ManagementDefinition,
        path: paths.managementDefinition,
    },
    transactionLog: {
        title: getLocalizedString("transactionLog"),
        component: pages.TransactionLog,
        path: paths.transactionLog,
    },
    generalValues: {
        title: getLocalizedString("generalValues"),
        component: pages.GeneralValues,
        path: paths.generalValues,
        parentRoute: paths.ratingsAndGeneralValues,
    },
    conceptStructure: {
        title: getLocalizedString("conceptStructure"),
        component: pages.ConceptStructure,
        path: paths.conceptStructure,
        parentRoute: paths.conceptsAndFormulasScreenSelector,
    },
    conceptsSet: {
        title: getLocalizedString("conceptsSet"),
        component: pages.ConceptsSet,
        path: paths.conceptSet,
        parentRoute: paths.conceptsAndFormulasScreenSelector,
    },
    extraHoursAuthorization: {
        title: getLocalizedString("extraHoursAuthorization"),
        component: pages.ExtraHoursAuthorization,
        path: paths.extraHoursAuthorization,
        parentRoute: paths.timeManagement,
    },
    extraHoursTable: {
        title: getLocalizedString("extraHoursTable"),
        component: pages.ExtraHoursTable,
        path: paths.extraHoursTable,
        parentRoute: paths.timeDefinition,
    },
    utils: {
        title: getLocalizedString("utils"),
        component: pages.Utils,
        path: paths.utils,
    },
    holidayTable: {
        title: getLocalizedString("holidayTable"),
        component: pages.HolidayTable,
        path: paths.holidayTable,
        parentRoute: paths.organizationalDefinitions,
    },
    festivitiesTable: {
        title: getLocalizedString("festivitiesTable"),
        component: pages.FestivitiesTable,
        path: paths.festivitiesTable,
        parentRoute: paths.organizationalDefinitions,
    },
    benefitsCenter: {
        title: getLocalizedString("benefitsCenter"),
        component: pages.BenefitsCenter,
        path: paths.benefitsCenter,
        parentRoute: paths.organizationalDefinitions,
    },
    projects: {
        title: getLocalizedString("projects"),
        component: pages.Projects,
        path: paths.projects,
        parentRoute: paths.organizationalDefinitions,
    },
    conceptGroups: {
        title: getLocalizedString("conceptGroups"),
        component: pages.ConceptGroups,
        path: paths.conceptGroups,
        parentRoute: paths.conceptsAndFormulasScreenSelector,
    },
    positionsClassificationSettings: {
        title: getLocalizedString("positionsClassification"),
        component: pages.PositionsClassificationSettings,
        path: paths.positionsClassification,
        parentRoute: paths.organizationalDefinitions,
    },
    laborUnions: {
        title: getLocalizedString("laborUnions"),
        component: pages.LaborUnions,
        path: paths.laborUnions,
        parentRoute: paths.organizationalDefinitions,
    },
    assetsDiscountsEntryByInstallments: {
        title: getLocalizedString("assetsDiscountsEntryByInstallments"),
        component: pages.AssetsDiscountsEntryByInstallments,
        path: paths.entryInInstallments,
        parentRoute: paths.assetsDiscounts,
    },
    paymentTypes: {
        title: getLocalizedString("paymentTypes"),
        component: pages.PaymentTypes,
        path: paths.paymentTypes,
        parentRoute: paths.organizationalDefinitions,
    },
    digitalWarehouseFileTypes: {
        title: getLocalizedString("digitalWarehouseFileTypes"),
        component: pages.DigitalWarehouseFileTypes,
        path: paths.digitalWarehouseFileTypes,
        parentRoute: paths.organizationalDefinitions,
    },
    ratingsAndGeneralValues: {
        title: getLocalizedString("ratingsAndGeneralValues"),
        component: pages.RatingsAndGeneralValues,
        path: paths.ratingsAndGeneralValues,
    },
    familyAsignations: {
        title: getLocalizedString("familyAsignations"),
        component: pages.FamilyAsignations,
        path: paths.familyAsignations,
        parentRoute: paths.generalValues,
    },
    ratings: {
        title: getLocalizedString("ratings"),
        component: pages.Ratings,
        path: paths.ratings,
        parentRoute: paths.generalValues,
    },
    taxTable: {
        title: getLocalizedString("taxTable"),
        component: pages.TaxTable,
        path: paths.taxTable,
        parentRoute: paths.generalValues,
    },
    affiliationInstitutionDefinition: {
        title: getLocalizedString("affiliationInstitutionDefinition"),
        component: pages.AffiliationInstitutionDefinition,
        path: paths.affiliationInstitutionDefinition,
    },
    retirementDefinition: {
        title: getLocalizedString("retirementDefinition"),
        component: pages.RetirementDefinition,
        path: paths.retirementDefinition,
        parentRoute: paths.affiliationInstitutionDefinition,
    },
    healthDefinition: {
        title: getLocalizedString("healthDefinition"),
        component: pages.HealthDefinition,
        path: paths.healthDefinition,
        parentRoute: paths.affiliationInstitutionDefinition,
    },
    digitalWarehouse: {
        title: getLocalizedString("digitalWarehouse"),
        component: pages.DigitalWarehouse,
        path: paths.digitalWarehouse,
    },
    trainingData: {
        title: getLocalizedString("trainingData"),
        component: pages.TrainingData,
        path: paths.trainingData,
    },
    schooling: {
        title: getLocalizedString("schooling"),
        component: pages.Schooling,
        path: paths.schooling,
        parentRoute: paths.trainingData,
    },
    studies: {
        title: getLocalizedString("studies"),
        component: pages.Studies,
        path: paths.studies,
        parentRoute: paths.trainingData,
    },
    specializations: {
        title: getLocalizedString("specializations"),
        component: pages.Specializations,
        path: paths.specializations,
        parentRoute: paths.trainingData,
    },
    languages: {
        title: getLocalizedString("languages"),
        component: pages.Languages,
        path: paths.languages,
        parentRoute: paths.trainingData,
    },
    accumulatorSettings: {
        title: getLocalizedString("accumulatorSettings"),
        component: pages.AccumulatorSettings,
        path: paths.accumulatorSettings,
        parentRoute: paths.conceptsAndFormulasScreenSelector,
    },
    payrollTypesSettings: {
        title: getLocalizedString("payrollTypesSettings"),
        component: pages.PayrollTypesSettings,
        path: paths.payrollTypes,
        parentRoute: paths.conceptsAndFormulasScreenSelector,
    },
    calculationReferences: {
        title: getLocalizedString("calculationReferences"),
        component: pages.CalculationReferences,
        path: paths.calculationReferences,
        parentRoute: paths.conceptsAndFormulasScreenSelector,
    },
    conceptsFormulasFunctionsScreenSelector: {
        title: getLocalizedString("conceptsAndFormulasScreenSelector"),
        component: pages.ConceptsFormulasFunctionsScreenSelector,
        path: paths.conceptsAndFormulasScreenSelector,
    },
    conceptsFormulas: {
        title: getLocalizedString("conceptsAndFormulas"),
        component: pages.ConceptsFormulasFunctions,
        path: paths.conceptsAndFormulas,
        parentRoute: paths.conceptsAndFormulasScreenSelector,
    },
    calculationsFunctions: {
        title: getLocalizedString("calculationsFunctions"),
        component: pages.ConceptsFormulasFunctions,
        path: paths.calculationsFunctions,
        parentRoute: paths.conceptsAndFormulasScreenSelector,
    },
    assetsAndDiscountsScreenSelector: {
        title: getLocalizedString("assetsAndDiscountsScreenSelector"),
        component: pages.AssetsAndDiscountsScreenSelector,
        path: paths.assetsDiscounts,
    },
    accountingImputations: {
        title: getLocalizedString("accountingImputations"),
        component: pages.AccountingImputations,
        path: paths.accountingImputations,
    },
    historicAccumulators: {
        title: getLocalizedString("historicAccumulators"),
        component: pages.HistoricAccumulators,
        path: paths.historicAccumulators,
    },
    assetsAndDiscountsCreation: {
        title: getLocalizedString("assetsAndDiscountsCreation"),
        component: pages.AssetsAndDiscountsCreation,
        path: paths.createAssetsDiscounts,
        parentRoute: paths.assetsDiscounts,
    },
    positionEditor: {
        title: getLocalizedString("positionEditor"),
        component: pages.PositionEditor,
        path: "/positionEditor",
    },
    orgChart: {
        title: getLocalizedString("orgChart"),
        component: pages.Orgchart,
        path: "/orgChart",
    },
    organizationStructure: {
        title: getLocalizedString("organizationStructure"),
        component: pages.OrganizationStructure,
        path: "/organizationStructure",
        parentRoute: paths.locationSettingsBox,
        extraParents: [paths.positions],
    },
    geographicalStructure: {
        title: getLocalizedString("geographicalStructure"),
        component: pages.GeographicalStructure,
        path: "/geographicalStructure",
        parentRoute: paths.locationSettingsBox,
    },
    requestsSettings: {
        title: getLocalizedString("requestsSettings"),
        component: pages.RequestsSettings,
        path: paths.requestsSettings,
    },
    advancesSettings: {
        title: getLocalizedString("advancesSettings"),
        component: pages.AdvancesSettings,
        path: paths.advancesSettings,
        parentRoute: paths.requestsSettings,
    },
    permissionsSettings: {
        title: getLocalizedString("permissionsSettings"),
        component: pages.PermissionsSettings,
        path: paths.permissionsSettings,
        parentRoute: paths.requestsSettings,
    },
    centersSettings: {
        title: getLocalizedString("centersSettings"),
        component: pages.CentersSettings,
        path: paths.centersSettings,
    },
    familySettings: {
        title: getLocalizedString("familySettings"),
        component: pages.FamilySettings,
        path: paths.familySettings,
        parentRoute: paths.organizationalDefinitions,
    },
    functionsSettings: {
        title: getLocalizedString("functionsSettings"),
        component: pages.FunctionsSettings,
        path: paths.functionsSettings,
        parentRoute: paths.organizationalDefinitions,
    },
    contractTypesSettings: {
        title: getLocalizedString("contractTypesSettings"),
        component: pages.ContractTypesSettings,
        path: paths.contractTypesSettings,
        parentRoute: paths.entryExitTypes,
    },
    actions: {
        title: getLocalizedString("actions"),
        component: pages.Actions,
        path: paths.actions,
        parentRoute: paths.myDesktop,
    },
    entryExitTypesScreenSelector: {
        title: getLocalizedString("entryExitTypes"),
        component: pages.EntryExitTypesScreenSelector,
        path: paths.entryExitTypes,
    },
    entryTypes: {
        title: getLocalizedString("entryTypes"),
        component: pages.EntryExitTypes,
        path: paths.entryTypes,
        parentRoute: paths.entryExitTypes,
    },
    exitTypes: {
        title: getLocalizedString("exitTypes"),
        component: pages.EntryExitTypes,
        path: paths.exitTypes,
        parentRoute: paths.entryExitTypes,
    },
    thirdPartySettings: {
        title: getLocalizedString("thirdPartySettings"),
        component: pages.ThirdPartySettings,
        path: paths.thirdPartySettings,
    },
    specialProcessDefinition: {
        title: getLocalizedString("specialProcessDefinition"),
        component: pages.SpecialProcessDefinition,
        path: paths.specialProcessDefinition,
        parentRoute: paths.extensibilityScreenSelector,
        extraParents: [paths.conceptsAndFormulasScreenSelector],
    },
    contractorSettings: {
        title: getLocalizedString("contractorSettings"),
        component: pages.ContractorSettings,
        path: paths.contractorSettings,
        parentRoute: paths.thirdPartySettings,
    },
    thirdPartyClassification: {
        title: getLocalizedString("thirdPartyClassification"),
        component: pages.ThirdPartyClassification,
        path: paths.thirdPartyClassification,
        parentRoute: paths.thirdPartySettings,
    },
    thirdParty: {
        title: getLocalizedString("thirdParty"),
        component: pages.ThirdParty,
        path: paths.thirdParty,
        parentRoute: paths.thirdPartySettings,
    },
    functionaryTypesSettings: {
        title: getLocalizedString("functionaryTypesSettings"),
        component: pages.FunctionaryTypesSettings,
        path: paths.functionaryTypesSettings,
        parentRoute: paths.organizationalDefinitions,
    },
    issueTypesSettingsScreenSelector: {
        title: getLocalizedString("issueTypesSettings"),
        component: pages.IssueTypesSettingsScreenSelector,
        path: paths.issueTypesSettings,
    },
    absenceTypes: {
        title: getLocalizedString("absenceTypes"),
        component: pages.IssueTypesSettings,
        path: paths.absenceTypes,
        parentRoute: paths.issueTypesSettings,
    },
    permissionTypes: {
        title: getLocalizedString("permissionTypes"),
        component: pages.IssueTypesSettings,
        path: paths.permissionTypes,
        parentRoute: paths.issueTypesSettings,
    },
    licenceTypes: {
        title: getLocalizedString("licenceTypes"),
        component: pages.IssueTypesSettings,
        path: paths.licenceTypes,
        parentRoute: paths.issueTypesSettings,
    },
    allergiesExamsDiseasesScreenSelector: {
        title: getLocalizedString("allergiesExamsDiseases"),
        component: pages.AllergiesExamsDiseasesScreenSelector,
        path: paths.allergiesExamsAndDiseases,
    },
    allergiesSettings: {
        title: getLocalizedString("allergiesSettings"),
        component: pages.AllergiesExamsDiseases,
        path: paths.allergiesSettings,
        parentRoute: paths.allergiesExamsAndDiseases,
    },
    examsSettings: {
        title: getLocalizedString("examsSettings"),
        component: pages.AllergiesExamsDiseases,
        path: paths.examsSettings,
        parentRoute: paths.allergiesExamsAndDiseases,
    },
    diseasesSettings: {
        title: getLocalizedString("diseasesSettings"),
        component: pages.AllergiesExamsDiseases,
        path: paths.diseasesSettings,
        parentRoute: paths.allergiesExamsAndDiseases,
    },
    organizationalDefinitionsScreenSelector: {
        title: getLocalizedString("organizationalDefinitions"),
        component: pages.OrganizationalDefinitionsScreenSelector,
        path: paths.organizationalDefinitions,
    },
    categoriesOrganizationalDefinitions: {
        title: getLocalizedString("categoriesSettings"),
        component: pages.OrganizationalDefinitions,
        path: paths.categoriesSettings,
        parentRoute: paths.organizationalDefinitions,
    },
    specialtiesOrganizationalDefinitions: {
        title: getLocalizedString("specialtiesSettings"),
        component: pages.OrganizationalDefinitions,
        path: paths.specialtiesSettings,
        parentRoute: paths.organizationalDefinitions,
    },
    locationSettingsBox: {
        title: getLocalizedString("locationSettingsBox"),
        component: pages.LocationSettingsBox,
        path: paths.locationSettingsBox,
    },
    locationSettings: {
        title: getLocalizedString("locationSettings"),
        component: pages.LocationSettings,
        path: paths.locationSettings,
        parentRoute: paths.locationSettingsBox,
    },
    worksAndTasksSettings: {
        title: getLocalizedString("worksAndTasksSettings"),
        component: pages.WorksAndTasksSettings,
        path: paths.worksAndTasks,
        parentRoute: paths.locationSettingsBox,
    },
    divisionsSettings: {
        title: getLocalizedString("divisionsSettings"),
        component: pages.DivisionsSettings,
        path: paths.divisionsSettings,
        parentRoute: paths.locationSettingsBox,
    },
    geoanalysis: {
        title: getLocalizedString("geoanalysisTitle"),
        component: pages.Geoanalysis,
        path: paths.geoanalysis,
    },
    benefitsDefinitions: {
        title: getLocalizedString("benefitsSettingsBox"),
        component: pages.BenefitsSettingsBox,
        path: paths.benefitsDefinitions,
    },
    digitalFolderAnalysis: {
        title: getLocalizedString("digitalFolderAnalysisTitle"),
        component: pages.DigitalFolderAnalysis,
        path: paths.digitalFolderAnalysis,
    },
    currentProcesses: {
        title: getLocalizedString("currentProcessesTitle"),
        component: pages.CurrentProcesses,
        path: paths.currentProcesses,
    },
    specialProcessExecution: {
        title: getLocalizedString("specialProcessExecution"),
        component: pages.SpecialProcessExecution,
        path: paths.specialProcessExecution,
    },
    historicalProcesses: {
        title: getLocalizedString("historicalProcessesTitle"),
        component: pages.HistoricalProcesses,
        path: paths.historicalProcesses,
    },
    rebuildAccumulators: {
        title: getLocalizedString("rebuildAccumulators"),
        component: pages.RebuildAccumulators,
        path: paths.rebuildAccumulators,
        parentRoute: paths.calculationManagement,
    },
    annotationsAnalysis: {
        title: getLocalizedString("annotationsAnalysisTitle"),
        component: pages.AnnotationsAnalysis,
        path: paths.annotationsAnalysis,
    },
    documentPublication: {
        title: getLocalizedString("documentPublication"),
        component: pages.DocumentPublication,
        path: paths.documentPublication,
        parentRoute: paths.documentsScreenSelector,
    },
    documentTemplates: {
        title: getLocalizedString("documentTemplates"),
        component: pages.DocumentTemplates,
        path: paths.documentTemplates,
        parentRoute: paths.documentsScreenSelector,
    },
    consentTypes: {
        title: getLocalizedString("consentTypes"),
        component: pages.ConsentTypes,
        path: paths.consentTypes,
        parentRoute: paths.consentsScreenSelector,
    },
    consentPublication: {
        title: getLocalizedString("consentPublication"),
        component: pages.ConsentPublication,
        path: paths.consentPublication,
        parentRoute: paths.consentsScreenSelector,
    },
    publicationSettings: {
        title: getLocalizedString("publicationSettings"),
        component: pages.PublicationSettings,
        path: paths.publicationSettings,
    },
    documentsScreenSelector: {
        title: getLocalizedString("documentsScreenSelector"),
        component: pages.DocumentsScreenSelector,
        path: paths.documentsScreenSelector,
    },
    consentsScreenSelector: {
        title: getLocalizedString("consentsScreenSelector"),
        component: pages.ConsentsScreenSelector,
        path: paths.consentsScreenSelector,
    },
    pollSettings: {
        title: getLocalizedString("pollSettings"),
        component: pages.PollSettings,
        path: paths.pollSettings,
        parentRoute: paths.pollScreenSelector,
    },
    generalSettings: {
        title: getLocalizedString("generalSettings"),
        component: pages.GeneralSettings,
        path: paths.generalSettings,
    },
    digitalFolderSettings: {
        title: getLocalizedString("digitalFolderSettingsTitle"),
        component: pages.DigitalFolderSettings,
        path: paths.digitalFolderSettings,
    },
    accessSettings: {
        title: getLocalizedString("accessSettingsTitle"),
        component: pages.AccessSettings,
        path: paths.accessSettings,
    },
    externalDocuments: {
        title: getLocalizedString("externalDocuments"),
        component: pages.ExternalDocuments,
        path: paths.externalDocuments,
    },
    signers: {
        title: getLocalizedString("DigitalSignatureTitle"),
        component: pages.Signers,
        path: paths.signers,
    },
    requestedDocuments: {
        title: getLocalizedString("requestedDocuments"),
        component: pages.RequestedDocuments,
        path: paths.requestedDocuments,
    },
    signedDocuments: {
        title: getLocalizedString("signedDocuments"),
        component: pages.SignedDocuments,
        path: paths.signedDocuments,
    },
    requests: {
        title: getLocalizedString("requestsControlTitle"),
        component: pages.Requests,
        path: paths.requestControl,
    },
    delegations: {
        title: getLocalizedString("delegationsTitle"),
        component: pages.DelegateAttentions,
        path: paths.delegations,
        parentRoute: paths.requestsMenu,
    },
    certificate: {
        title: getLocalizedString("certificateTitle"),
        component: pages.Certificates,
        path: paths.certificates,
    },
    digitalCertificates: {
        title: getLocalizedString("digitalCertificates"),
        component: pages.Certificates,
        path: paths.digitalCertificates,
    },
    myCertificates: {
        title: getLocalizedString("myCertificateTitle"),
        component: pages.Home,
        path: paths.myCertificates,
    },
    pollScreenSelector: {
        title: getLocalizedString("pollScreenSelector"),
        component: pages.PollScreenSelector,
        path: paths.pollScreenSelector,
    },
    recognitionScreenSelector: {
        title: getLocalizedString("recognitionScreenSelector"),
        component: pages.RecognitionScreenSelector,
        path: paths.recognitionScreenSelector,
    },
    recognitionAnalysis: {
        title: getLocalizedString("recognitionAnalysis"),
        component: pages.RecognitionAnalysis,
        path: paths.recognitionAnalysis,
        parentRoute: paths.recognitionScreenSelector,
    },
    nineBoxClassification: {
        title: getLocalizedString("nineBoxClassification"),
        component: pages.NineBoxClassification,
        path: paths.nineBoxClassification,
        parentRoute: paths.talentClassification,
    },
    pollReview: {
        title: getLocalizedString("pollReview"),
        component: pages.PollReview,
        path: paths.pollReview,
        parentRoute: paths.pollScreenSelector,
    },
    pollComparison: {
        title: getLocalizedString("pollComparison"),
        component: pages.PollComparison,
        path: paths.pollComparison,
        parentRoute: paths.pollScreenSelector,
    },
    myVacations: {
        title: getLocalizedString("myVacationsTitle"),
        path: paths.myVacations,
        component: pages.Home,
        parentRoute: paths.personal,
    },
    vacations: {
        title: getLocalizedString("vacationsTitle"),
        path: paths.vacations,
        component: pages.Vacations,
        parentRoute: paths.personal,
    },
    performanceForms: {
        title: getLocalizedString("performanceForms"),
        path: paths.performanceForms,
        component: pages.PerformanceForms,
        parentRoute: paths.performanceDefinition,
    },
    talentClassification: {
        title: getLocalizedString("talentClassification"),
        path: paths.talentClassification,
        component: pages.NineBoxScreenSelector,
    },
    performanceEvaluations: {
        title: getLocalizedString("performanceEvaluations"),
        path: paths.performanceEvaluations,
        component: pages.PerformanceEvaluations,
    },
    performanceAnalytics: {
        title: getLocalizedString("performanceAnalytics"),
        path: paths.performanceAnalytics,
        component: pages.PerformanceAnalyticsScreenSelector,
    },
    performanceAnalyticsHistoric: {
        title: getLocalizedString("performanceAnalyticsHistoric"),
        path: paths.performanceAnalyticsHistoric,
        component: pages.PerformanceAnalyticsHistoric,
        parentRoute: paths.performanceAnalytics,
    },
    performanceAnalyticsEvaluations: {
        title: getLocalizedString("performanceAnalyticsEvaluations"),
        path: paths.performanceAnalyticsEvaluations,
        component: pages.PerformanceAnalyticsEvaluations,
        parentRoute: paths.performanceAnalytics,
    },
    performanceAnalyticsTalent: {
        title: getLocalizedString("performanceAnalyticsTalent"),
        path: paths.performanceAnalyticsTalent,
        component: pages.PerformanceAnalyticsTalent,
        parentRoute: paths.performanceAnalytics,
    },
    performanceEvaluationsCalibration: {
        title: getLocalizedString("performanceEvaluationsCalibration"),
        path: paths.performanceEvaluationsCalibration,
        component: pages.PerformanceEvaluationsCalibration,
    },
    performanceInterviewAndFeedback: {
        title: getLocalizedString("performanceInterviewAndFeedback"),
        path: paths.performanceInterviewAndFeedback,
        component: pages.PerformanceInterviewAndFeedback,
    },
    performanceSummaryAndResults: {
        title: getLocalizedString("performanceSummaryAndResults"),
        path: paths.performanceSummaryAndResults,
        component: pages.PerformanceSummaryAndResults,
    },
    onboardingTracking: {
        title: getLocalizedString("onboardingTracking"),
        path: paths.onboardingTracking,
        component: pages.OnboardingTracking,
        parentRoute: paths.onboardingScreenSelector,
    },
    myOnboardingTracking: {
        title: getLocalizedString("myOnboardingTracking"),
        path: paths.myOnboardingTracking,
        component: pages.MyOnboardingTracking,
        parentRoute: paths.onboardingScreenSelector,
    },
    onboardingProcesses: {
        title: getLocalizedString("onboardingProcesses"),
        path: paths.onboardingProcesses,
        component: pages.OnboardingProcesses,
        parentRoute: paths.onboardingScreenSelector,
    },
    onboardingProcessesAssignment: {
        title: getLocalizedString("onboardingProcessesAssignment"),
        path: paths.onboardingProcessesAssignment,
        component: pages.OnboardingProcessesAssignment,
    },
    evaluationProcessDefinition: {
        title: getLocalizedString("evaluationProcessDefinition"),
        path: paths.evaluationProcessDefinition,
        component: pages.EvaluationProcessDefinition,
    },
    evaluationProcessDefinitionAssignment: {
        title: getLocalizedString("evaluationProcessDefinitionAssignment"),
        component: pages.EvaluationProcessDefinitionAssignment,
        path: paths.evaluationProcessDefinitionAssignment,
    },
    performanceDefinition: {
        title: getLocalizedString("performanceDefinition"),
        path: paths.performanceDefinition,
        component: pages.PerformanceDefinition,
    },
    loans: {
        title: getLocalizedString("loansTitle"),
        component: pages.Loans,
        path: paths.loans,
    },
    receipts: {
        title: getLocalizedString("receiptsTitle"),
        component: pages.Receipts,
        path: paths.receipts,
    },
    digitalReceipts: {
        title: getLocalizedString("digitalReceipts"),
        component: pages.Receipts,
        path: paths.digitalReceipts,
    },
    myReceipts: {
        title: getLocalizedString("myReceiptsTitle"),
        component: pages.Home,
        path: paths.myReceipts,
    },
    myHistoricalReceipts: {
        title: getLocalizedString("myHistoricalReceiptsTitle"),
        component: pages.Home,
        path: paths.myHistoricalReceipts,
        requireAuth: false,
    },
    myRequests: {
        title: getLocalizedString("myRequests"),
        component: pages.MyRequests,
        path: paths.myRequests,
    },
    myRequestsManager: {
        title: getLocalizedString("myRequestsManager"),
        component: pages.MyRequestsManager,
        path: paths.myRequestsManager,
    },
    totemManagement: {
        title: getLocalizedString("totemManagementTitle"),
        component: pages.TotemManagement,
        path: paths.totems,
        parentRoute: paths.timeDefinition,
    },
    myAssistance: {
        title: getLocalizedString("myAssistanceTitle"),
        component: pages.MyAssistance,
        path: paths.myAssistance,
        parentRoute: paths.timeManagement,
    },
    myPeopleSchedule: {
        title: getLocalizedString("myPeopleSchedule"),
        component: pages.MyPeopleSchedule,
        path: paths.myPeopleSchedule,
    },
    mySchedule: {
        title: getLocalizedString("mySchedule"),
        component: pages.MySchedule,
        path: paths.mySchedule,
    },
    assistance: {
        title: getLocalizedString("assistanceTitle"),
        component: pages.Assistance,
        path: paths.assistance,
        parentRoute: paths.timeManagement,
    },
    query: {
        title: getLocalizedString("query"),
        component: pages.Queries,
        path: paths.queries,
    },
    myPeople: {
        title: getLocalizedString("myPeopleTitle"),
        component: pages.MyPeople,
        path: paths.myPeople,
    },
    employeeMaster: {
        title: getLocalizedString("employeeMaster"),
        component: pages.MyPeople,
        path: paths.peopleMaster,
    },
    issueSummary: {
        title: getLocalizedString("issueSummary"),
        component: pages.IssueSummary,
        path: paths.issueSummary,
        parentRoute: paths.issueManagementScreenSelector,
    },
    issueLicences: {
        title: getLocalizedString("issueLicences"),
        component: pages.IssueLicences,
        path: paths.issueLicences,
        parentRoute: paths.issueManagementScreenSelector,
    },
    issuePermissions: {
        title: getLocalizedString("issuePermissions"),
        component: pages.IssuePermissions,
        path: paths.issuePermissions,
        parentRoute: paths.issueManagementScreenSelector,
    },
    issueAbsences: {
        title: getLocalizedString("issueAbsences"),
        component: pages.IssueAbsences,
        path: paths.issueAbsences,
        parentRoute: paths.issueManagementScreenSelector,
    },
    issueVacations: {
        title: getLocalizedString("issueVacations"),
        component: pages.IssueVacations,
        path: paths.issueVacations,
        parentRoute: paths.issueManagementScreenSelector,
    },
    issueManagementScreenSelector: {
        title: getLocalizedString("issueManagementScreenSelector"),
        component: pages.IssueManagementScreenSelector,
        path: paths.issueManagementScreenSelector,
    },
    entryPerConcept: {
        title: getLocalizedString("entryPerConcept"),
        component: pages.AssetsDiscountsEntryPerConcept,
        path: paths.entryPerConcept,
        parentRoute: paths.assetsDiscounts,
    },
    dataCapture: {
        title: getLocalizedString("dataCapture"),
        component: pages.AssetsDiscountsEntryByAPI,
        path: paths.dataCapture,
        parentRoute: paths.assetsDiscounts,
    },
    massEntry: {
        title: getLocalizedString("massEntry"),
        component: pages.AssetsDiscountsMassiveEntry,
        path: paths.massEntry,
        parentRoute: paths.assetsDiscounts,
    },
    entryPerSociety: {
        title: getLocalizedString("entryPerSociety"),
        component: pages.AssetsDiscountsEntryPerSociety,
        path: paths.entryPerSociety,
        parentRoute: paths.assetsDiscounts,
    },
    myApprovedConsents: {
        title: getLocalizedString("myApprovedConsents"),
        component: pages.MyApprovedConsents,
        path: paths.myApprovedConsents,
    },
    assetsDiscountsSummary: {
        title: getLocalizedString("assetsDiscountsSummary"),
        component: pages.AssetsDiscountsSummary,
        path: paths.assetsDiscountsSummary,
        parentRoute: paths.assetsDiscounts,
    },
    attendanceReport: {
        title: getLocalizedString("attendanceReport"),
        component: pages.AttendanceReport,
        path: paths.attendanceReport,
    },
    entryPerConceptSet: {
        title: getLocalizedString("entryPerConceptSet"),
        component: pages.AssetsDiscountsEntryPerConceptSet,
        path: paths.entryPerConceptSet,
        parentRoute: paths.assetsDiscounts,
    },
    processScheduling: {
        title: getLocalizedString("processScheduling"),
        component: pages.ProcessScheduling,
        path: paths.processScheduling,
    },
    entryByImport: {
        title: getLocalizedString("entryByImport"),
        component: pages.AssetsDiscountsEntryByImport,
        path: paths.entryByImport,
        parentRoute: paths.assetsDiscounts,
    },
    kpiIndicators: {
        title: getLocalizedString("kpiIndicators"),
        component: pages.KpiIndicators,
        path: paths.kpiIndicators,
    },
    typesOfBenefits: {
        title: getLocalizedString("typesOfBenefits"),
        component: pages.TypesOfBenefits,
        path: paths.typesOfBenefits,
        parentRoute: paths.benefitsDefinitions,
    },
    recognitionPlans: {
        title: getLocalizedString("recognitionPlans"),
        component: pages.RecognitionPlans,
        path: paths.recognitionPlans,
        parentRoute: paths.recognitionScreenSelector,
    },
    recognitionPlansAssignment: {
        title: getLocalizedString("recognitionPlansAssignment"),
        component: pages.RecognitionPlansAssignment,
        path: paths.recognitionPlansAssignment,
    },
    benefitsForPlans: {
        title: getLocalizedString("benefitsForPlans"),
        component: pages.BenefitsForPlans,
        path: paths.benefitsForPlans,
        parentRoute: paths.recognitionScreenSelector,
    },
    organizationalBenefits: {
        title: getLocalizedString("organizationalBenefits"),
        component: pages.OrganizationalBenefits,
        path: paths.organizationalBenefits,
        parentRoute: paths.benefitsDefinitions,
    },
    feedbackPurpose: {
        title: getLocalizedString("feedbackPurpose"),
        component: pages.FeedbackPurpose,
        path: paths.feedbackPurpose,
        parentRoute: paths.organizationalDefinitions,
        extraParents: [paths.performanceDefinition],
    },
    groupClassification: {
        title: getLocalizedString("groupClassification"),
        component: pages.GroupClassification,
        path: paths.groupClassification,
        parentRoute: paths.organizationalDefinitions,
    },
    bankSettings: {
        title: getLocalizedString("bankSettings"),
        component: pages.BankSettings,
        path: paths.bankSettings,
        parentRoute: paths.thirdPartySettings,
    },
    currencySettings: {
        title: getLocalizedString("currencySettings"),
        component: pages.CurrencySettings,
        path: paths.currencySettings,
        parentRoute: paths.organizationalDefinitions,
    },
    actionTypes: {
        title: getLocalizedString("actionTypes"),
        component: pages.ActionTypes,
        path: paths.actionTypes,
        parentRoute: paths.organizationalDefinitions,
    },
    nineBoxSettings: {
        title: getLocalizedString("nineBoxSettings"),
        component: pages.NineBoxSettings,
        path: paths.nineBoxSettings,
        parentRoute: paths.talentClassification,
    },
    reasonForPointAwarding: {
        title: getLocalizedString("reasonForPointAwarding"),
        component: pages.ReasonForPointAwarding,
        path: paths.reasonForPointAwarding,
        parentRoute: paths.benefitsDefinitions,
    },
    myQueries: {
        title: getLocalizedString("myQueries"),
        component: pages.Queries,
        path: paths.myQueries,
    },
    myPending: {
        title: getLocalizedString("myPending"),
        component: pages.MyPending,
        path: paths.myPending,
    },
    myPendingEmployer: {
        title: getLocalizedString("myPendingEmployer"),
        component: pages.MyPendingEmployer,
        path: paths.myPendingEmployer,
    },
    timeDefinition: {
        title: getLocalizedString("timeDefinition"),
        component: pages.TimeDefinition,
        path: paths.timeDefinition,
    },
    turnDefinition: {
        title: getLocalizedString("turnDefinition"),
        component: pages.TurnDefinition,
        path: paths.turnDefinition,
        parentRoute: paths.timeDefinition,
    },
    schedulesDefinition: {
        title: getLocalizedString("schedulesDefinition"),
        component: pages.SchedulesDefinition,
        path: paths.schedulesDefinition,
        parentRoute: paths.timeDefinition,
    },
    calendarDefinition: {
        title: getLocalizedString("calendarDefinition"),
        component: pages.CalendarDefinition,
        path: paths.calendarDefinition,
        parentRoute: paths.timeDefinition,
    },
    schedulesProgramming: {
        title: getLocalizedString("schedulesProgramming"),
        component: pages.SchedulesProgramming,
        path: paths.schedulesProgramming,
        parentRoute: paths.timeDefinition,
    },
    myAnnexes: {
        title: getLocalizedString("myAnnexesTitle"),
        component: pages.MyAnnexes,
        path: paths.myDigitalFolder,
    },
    myAnnotations: {
        title: getLocalizedString("myAnnotationsTitle"),
        component: pages.MyAnnotations,
        path: paths.myAnnotations,
    },
    myBenefits: {
        title: getLocalizedString("myBenefits"),
        component: pages.MyBenefits,
        path: paths.myBenefits,
    },
    home: {
        title: getLocalizedString("mainTitle"),
        component: pages.Home,
        path: paths.home,
    },
    notes: {
        title: getLocalizedString("notes"),
        component: pages.Notes,
        path: paths.notes,
    },
    myDesktop: {
        title: getLocalizedString("myDesktop"),
        component: pages.MyDesktop,
        path: paths.myDesktop,
    },
    feed: {
        title: getLocalizedString("feed"),
        component: pages.Feed,
        path: paths.feed,
    },
    feedback: {
        title: getLocalizedString("feedback"),
        component: pages.Feedback,
        path: paths.feedback,
        parentRoute: paths.myDesktop,
    },
    communicationChannel: {
        title: getLocalizedString("communicationChannel"),
        component: pages.CommunicationChannel,
        path: paths.communicationChannel,
        parentRoute: paths.myDesktop,
    },
    communicationClassification: {
        title: getLocalizedString("communicationClassification"),
        component: pages.CommunicationClassification,
        path: paths.communicationClassification,
        parentRoute: paths.organizationalDefinitions,
    },
    requestDocuments: {
        title: getLocalizedString("requestDocuments"),
        component: pages.Home,
        path: paths.requestDocuments,
    },
    extensibilityScreenSelector: {
        title: getLocalizedString("extensibilityScreenSelector"),
        component: pages.ExtensibilityScreenSelector,
        path: paths.extensibilityScreenSelector,
    },
    userTablesDefinition: {
        title: getLocalizedString("userTablesDefinition"),
        component: pages.SystemAndUserTablesDefinition,
        path: paths.userTablesDefinition,
        parentRoute: paths.extensibilityScreenSelector,
    },
    systemTablesDefinition: {
        title: getLocalizedString("systemTablesDefinition"),
        component: pages.SystemAndUserTablesDefinition,
        path: paths.systemTablesDefinition,
        parentRoute: paths.extensibilityScreenSelector,
    },
    relatedTablesDefinition: {
        title: getLocalizedString("relatedTablesDefinition"),
        component: pages.RelatedTablesDefinition,
        path: paths.relatedTablesDefinition,
        parentRoute: paths.extensibilityScreenSelector,
    },
    userTables: {
        title: getLocalizedString("userTables"),
        component: pages.SystemAndUserTables,
        path: paths.userTables,
    },
    systemTables: {
        title: getLocalizedString("systemTables"),
        component: pages.SystemAndUserTables,
        path: paths.systemTables,
    },
    catalogs: {
        title: getLocalizedString("catalogs"),
        component: pages.Catalogs,
        path: paths.catalogs,
        parentRoute: paths.extensibilityScreenSelector,
    },
    userMenus: {
        title: getLocalizedString("userMenus"),
        component: pages.UserMenus,
        path: paths.userMenus,
        parentRoute: paths.extensibilityScreenSelector,
    },
    socialBlacklist: {
        title: getLocalizedString("socialBlacklist"),
        component: pages.SocialBlacklist,
        path: paths.socialBlacklist,
    },
    typesOfObjectives: {
        title: getLocalizedString("typesOfObjectives"),
        component: pages.TypesOfObjectives,
        path: paths.typesOfObjectives,
        parentRoute: paths.performanceDefinition,
    },
    typesOfScore: {
        title: getLocalizedString("typesOfScore"),
        component: pages.TypesOfScore,
        path: paths.typesOfScore,
        parentRoute: paths.performanceDefinition,
    },
    ratingScales: {
        title: getLocalizedString("ratingScales"),
        component: pages.RatingScales,
        path: paths.ratingScales,
        parentRoute: paths.performanceDefinition,
    },
    positionGroupsForEvaluations: {
        title: getLocalizedString("positionGroupsForEvaluations"),
        component: pages.PositionGroupsForEvaluations,
        path: paths.positionGroupsForEvaluations,
        parentRoute: paths.performanceDefinition,
    },
    periodsForObjectives: {
        title: getLocalizedString("periodsForObjectives"),
        component: pages.PeriodsForObjectives,
        path: paths.periodsForObjectives,
        parentRoute: paths.performanceDefinition,
    },
    typesOfSkillsSpecific: {
        title: getLocalizedString("typesOfSkillsSpecific"),
        component: pages.TypesOfSkillsSpecific,
        path: paths.typesOfSkillsSpecific,
        parentRoute: paths.performanceDefinition,
    },
    typesOfSkillsTransversal: {
        title: getLocalizedString("typesOfSkillsTransversal"),
        component: pages.TypesOfSkillsTransversal,
        path: paths.typesOfSkillsTransversal,
        parentRoute: paths.performanceDefinition,
    },
    goalsAndObjectives: {
        title: getLocalizedString("goalsAndObjectivesTitle"),
        component: pages.GoalsAndObjectives,
        path: paths.goalsAndObjectives,
    },
    talentAcquisitionSettings: {
        title: getLocalizedString("talentAcquisitionSettings"),
        component: pages.TalentAcquisitionSettings,
        path: paths.talentAcquisitionSettings,
    },
    onboardingScreenSelector: {
        title: getLocalizedString("onboardingScreenSelector"),
        component: pages.OnboardingScreenSelector,
        path: paths.onboardingScreenSelector,
    },
    classificationApplicantsTypes: {
        title: getLocalizedString("classificationApplicantsTypes"),
        component: pages.ClassificationApplicantsTypes,
        path: paths.classificationApplicantsTypes,
        parentRoute: paths.talentAcquisitionSettings,
    },
    typesOfPublicationChannels: {
        title: getLocalizedString("typesOfPublicationChannels"),
        component: pages.TypesOfPublicationChannels,
        path: paths.typesOfPublicationChannels,
        parentRoute: paths.talentAcquisitionSettings,
    },
    typesOfPublicationFormats: {
        title: getLocalizedString("typesOfPublicationFormats"),
        component: pages.TypesOfPublicationFormats,
        path: paths.typesOfPublicationFormats,
        parentRoute: paths.talentAcquisitionSettings,
    },
    typesOfOnboardingActions: {
        title: getLocalizedString("typesOfOnboardingActions"),
        component: pages.TypesOfOnboardingActions,
        path: paths.typesOfOnboardingActions,
        parentRoute: paths.talentAcquisitionSettings,
    },
    onboardingProfiles: {
        title: getLocalizedString("onboardingProfiles"),
        path: paths.onboardingProfiles,
        component: pages.OnboardingProfiles,
        parentRoute: paths.talentAcquisitionSettings,
    },
    onboardingMaterials: {
        title: getLocalizedString("onboardingMaterials"),
        path: paths.onboardingMaterials,
        component: pages.OnboardingMaterials,
        parentRoute: paths.talentAcquisitionSettings,
    },
    trainingAndDevelopment: {
        title: getLocalizedString("trainingAndDevelopment"),
        path: paths.trainingAndDevelopment,
        component: pages.TrainingAndDevelopmentScreenSelector,
    },
    collaboratorSkillsRanking: {
        title: getLocalizedString("collaboratorRanking"),
        path: paths.collaboratorSkillsRanking,
        component: pages.CollaboratorSkillsRanking,
        parentRoute: paths.trainingAndDevelopment,
    },
    coursesMaster: {
        title: getLocalizedString("coursesMaster"),
        path: paths.coursesMaster,
        component: pages.CoursesMaster,
        parentRoute: paths.trainingAndDevelopment,
    },
    trainingDefinition: {
        title: getLocalizedString("training"),
        path: paths.trainingDefinition,
        component: pages.TrainingDefinition,
        parentRoute: paths.trainingAndDevelopment,
    },
    myTraining: {
        title: getLocalizedString("lms"),
        path: paths.myTraining,
        component: pages.MyTraining,
        parentRoute: paths.trainingAndDevelopment,
    },
    modulesAndMenus: {
        title: getLocalizedString("modulesAndMenus"),
        path: paths.modulesAndMenus,
        component: pages.ModulesAndMenus,
    },
});